import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableHead, TableRow, Button, TextField, Box, Typography } from '@mui/material';

interface BimObject {
  id: string;
  globalId: string;
  ifcType: string;
  name?: string;
  weclappCustomerId?: string;
  weclappData?: { company?: string };
  properties: { data: { NetArea?: number; /* Passe an deine Quantities an */ } }[];
}

interface Stats {
  wallCount: number;
  spaceCount: number;
  totalArea: number;
}

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const App: React.FC = () => {
  const [objects, setObjects] = useState<BimObject[]>([]);
  const [stats, setStats] = useState<Stats>({ wallCount: 0, spaceCount: 0, totalArea: 0 });
  const [selectedId, setSelectedId] = useState('');
  const [customerNumber, setCustomerNumber] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/objects`);
      setObjects(res.data.objects);
      setStats(res.data.stats);
    } catch (err) {
      console.error('Error fetching data:', err);
      alert('Fehler beim Laden der Daten');
    }
  };

  const handleLink = async () => {
    if (!customerNumber) {
      alert('Bitte gib eine Kundennummer ein');
      return;
    }
    try {
      await axios.post(`${API_URL}/api/link-weclapp`, { bimObjectId: selectedId, customerNumber });
      alert('Verknüpft!');
      setSelectedId('');
      setCustomerNumber('');
      fetchData(); // Refresh Daten
    } catch (err) {
      alert('Fehler beim Verknüpfen: ' + (err as Error).message);
    }
  };

  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('ifcFile', file);
    try {
      await axios.post(`${API_URL}/api/import-ifc`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('IFC hochgeladen!');
      fetchData(); // Refresh
    } catch (err) {
      alert('Fehler beim Hochladen: ' + (err as Error).message);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5">
        Statistiken: Wände: {stats.wallCount}, Räume: {stats.spaceCount}, Gesamtfläche: {stats.totalArea} m²
      </Typography>
      
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Typ</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Verknüpfter Kunde</TableCell>
            <TableCell>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {objects.map(obj => (
            <TableRow key={obj.id}>
              <TableCell>{obj.id}</TableCell>
              <TableCell>{obj.ifcType}</TableCell>
              <TableCell>{obj.name}</TableCell>
              <TableCell>{obj.weclappData?.company || 'Keiner'}</TableCell>
              <TableCell>
                <Button onClick={() => setSelectedId(obj.id)}>Verknüpfen</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      
      {selectedId && (
        <Box mt={2}>
          <TextField 
            label="Weclapp Customer Number" 
            value={customerNumber} 
            onChange={e => setCustomerNumber(e.target.value)} 
            fullWidth
          />
          <Button onClick={handleLink} disabled={!customerNumber}>Bestätigen</Button>
        </Box>
      )}
    </Box>
  );
};

export default App;